import { connect } from 'react-redux';
import App from './App';
import { getUserInfo } from './actions/user';

const mapStateToProps = ({ user, currentOrganisation }) => ({
  user,
  currentOrganisation,
});

const mapDispatchToProps = dispatch => ({
  getUserInfo: () => dispatch(getUserInfo()),
});

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/AppContainer.js